"use client"

import { useMemo } from 'react'
import Link from 'next/link'
import useSWR from 'swr'
import { useUnread } from '@components/messages/unread'
import { accountHome, accountLinks } from '@components/session/UserNav'
import { casesLabel, usePanelLink } from '@components/session/panelLink'
import useAccountSummary from '@hooks/user/useAccountSummary'
import storage from '@utils/localStorage'
import checkLogin from '@utils/checkLogin'
import { useMenuOpen } from './MenuControl'
import { MenuGroup, MenuLinks } from './MenuParts'
import { LOGIN_PAGE, NEW_ACCOUNT_PAGE, USER_WATCHED } from '@constants/routes'

import styles from './SiteHeader.module.css'

const HOST = process.env.NEXT_PUBLIC_HOST
const guestLinks = [
    { t: 'Zaloguj się', to: HOST + LOGIN_PAGE },
    { t: 'Załóż konto', to: HOST + NEW_ACCOUNT_PAGE },
    { t: 'Obserwowane', to: HOST + USER_WATCHED },
]

function AccountLinks ({ user }) {
    const { total: unread } = useUnread()
    const summary = useAccountSummary(user, useMenuOpen())
    const links = useMemo(() => accountLinks(user, summary), [user, summary])
    const panel = usePanelLink(true)

    return (
        <>
            <li>
                <Link className={styles.menuLink} href={accountHome.href} prefetch={false}><b>{accountHome.t}</b></Link>
            </li>
            { panel &&
                <li>
                    <a className={styles.menuLink} href={panel.href}>{panel.t}{ panel.count > 0 && <span className={styles.menuBadge}>{casesLabel(panel.count)}</span> }</a>
                </li> }
            { links.map(link => {
                const pending = link.key === 'ogloszenia' && summary?.pending
                const messages = link.key === 'wiadomosci' && unread
                const inner = <>
                    {link.t}
                    { pending > 0 && <span className={styles.menuBadge}>{pending} do opłacenia</span> }
                    { messages > 0 && <span className={`${styles.menuBadge} ${styles.unreadBadge}`}>{messages} {messages === 1 ? 'nieprzeczytana' : 'nieprzeczytane'}</span> }
                </>
                return (
                    <li key={link.key}>
                        <Link className={styles.menuLink} href={link.href} prefetch={false}>{inner}</Link>
                    </li>
                )
            }) }
        </>
    )
}

// Do odczytu sesji grupa jest niewidoczna (bez mignięcia wariantu gościa). W panelu stoi na końcu, w szufladzie
// pierwsza (CSS) — sesja jest odczytana, zanim szufladę można otworzyć.
export default function MenuAccountGroup () {
    const { data: user } = useSWR('user', storage)
    const isLoggedIn = checkLogin(user)

    return (
        <MenuGroup className={styles.menuAccount} data-ready={user === undefined ? undefined : ''} id="mg-konto" label="Konto">
            { isLoggedIn ? <AccountLinks user={user} /> : <MenuLinks links={guestLinks} /> }
        </MenuGroup>
    )
}
